import { Collapse } from "bootstrap";

let productId = null;
let variationSelect: HTMLSelectElement|null = null;
const variationIdInput: HTMLInputElement = document.querySelector('[name=variation_id]');

interface FeatureIcon {
    title: string;
    url: string;
}

interface Drawing {
    title: string;
    url: string;
}

interface Download {
    name: string;
    url: string;
}

interface Image {
    id: number;
    path: string;
    webPath: string;
}

interface VariationData {
    status: string;
    message?: string;
    spec: object;
    feature_icons: FeatureIcon[]
    drawings: Drawing[]
    downloads: Download[]
    images: Image[]
}
    
// Elements
const specificationContainer = document.querySelector('#product_specification');
const downloadsContainer = document.querySelector('#product_downloads');
const variationLogosContainer = document.querySelector('#variation_logos');
const drawingsContainer = document.querySelector('#product_drawings');
const imageLoader = document.querySelector('#product_image_loader');
const imageMain = document.querySelector('#product_main_image') as HTMLImageElement;
const imageThumbnails = document.querySelector('#product_image_thumbnails');
const imageContainer = document.querySelector('#product_image_container');
const imageError = document.querySelector('#product_image_error');

// let imageLightbox: GLightbox|null = null;

async function showLoader(isShown: boolean) {
    imageLoader.classList.toggle('d-none', !isShown);
    imageContainer.classList.toggle('d-none', isShown);

    if (isShown) {
        specificationContainer.innerHTML = 'Specification is loading...';
        downloadsContainer.innerHTML = 'Downloads are loading...';
        drawingsContainer.innerHTML = 'Drawings are loading...';
        variationLogosContainer.innerHTML = '<div class="feature-icon block-shine"></div>'.repeat(Math.round(Math.random() * 3) + 5);
    }
}

async function changeImage(imageElement: HTMLImageElement) {
    imageMain.src = imageElement.src;
    imageMain.alt = imageElement.alt;

    const thumbnails = imageThumbnails.querySelectorAll('img');

    thumbnails.forEach(el => {
        el.classList.remove('border-black');
    });

    imageElement.classList.add('border-black');
}

async function changeVariation(productId: number) {
    showLoader(true);

    // Get variation information
    const url = new URL(`/flow-api/v1/product/info/${productId}`, window.location.origin);

    // url.searchParams.set('product_id', productId.toString());

    const response = await fetch(url.toString());
    const data = await response.json() as VariationData;

    if (data.status === 'error') {
        console.log('Product not found');
        imageError.classList.toggle('d-none', true);
        showLoader(false);
        return;
    }

    const { spec, feature_icons, downloads, drawings, images } = data;

    /**
     * Specification
     */
    let specHtml = '';

    for (let [headerName, options] of Object.entries(spec)) {
        // specHtml += `<h2>${headerName}</h2>`

        let groupHtml = '';

        for (let [optionName, optionValue] of Object.entries(options)) {
            groupHtml += `<div class="row mb-2"><div class="col-12 col-md-4 fw-bold">${optionName}</div><div class="col">${optionValue}</div></div>`
        }

        const groupSlug = headerName.toLowerCase().replace(/ /g, "").replace(/[^\w-]+/g, "");

        specHtml += `<div class="card">
    <div class="card-header d-flex justify-content-between" data-bs-toggle="collapse" data-bs-target="#${groupSlug}" aria-expanded="false" aria-controls="${groupSlug}">
        <h4 class="mb-0">${headerName}</h4>

        <div class="btn btn-outline-secondary">Toggle</div>
    </div>

    <div class="collapse" id="${groupSlug}">
        <div class="card-body">${groupHtml}</div>
    </div>
</div>`
    }

    specificationContainer.innerHTML = specHtml;

    const collapseElementList = specificationContainer.querySelectorAll('.collapse')
    const collapseList = [...collapseElementList].map(collapseEl => new Collapse(collapseEl))

    /**
     * Feature logos
     */
    let iconsHtml = '';

    for (const icon of feature_icons ?? []) {
        iconsHtml += `<img class="feature-icon" src="${icon.url}" width="40" alt="Feature icon" />`;
    }

    variationLogosContainer.innerHTML = iconsHtml;

    /**
     * Downloads
     */
    let downloadsHtml = '';

    for (const download of downloads ?? []) {
        downloadsHtml += `<div class="row align-items-center"><div class="col-md-2 col-3 fw-bold">${download.name}</div><div class="col"><a class="btn btn-light" href="${download.url}">Download</a></div></div>`;
    }

    downloadsContainer.innerHTML = downloadsHtml;

    /**
     * Downloads
     */
    let drawingsHtml = '<div class="row align-items-center">';

    if (drawings) {
        for (const drawing of drawings ?? []) {
            drawingsHtml += `<div class="col-lg-6 fw-bold"><h2>${drawing.title}</h2><img class="img-fluid w-100" src="${drawing.url}" alt="${drawing.title}" /></div>`;
        }
    } else {
        drawingsHtml = '<p>There are no drawings for the given product.</p>'
    }

    drawingsContainer.innerHTML = drawingsHtml + '</div>';

    /**
     * Images
     */
    imageThumbnails.innerHTML = '';

    // const lightboxImages = [];

    for (const image of images) {
        const element = document.createElement('div');
        
        element.classList.add('col-md-2', 'col-3', 'p-1');
        element.innerHTML = `<img class="img-thumbnail" src="${image.webPath}" alt="Product image">`

        imageThumbnails.append(element);

        element.onclick = () => changeImage(element.querySelector('img'));

        /* lightboxImages.push({
            type: 'image',
            href: image.path
        }) */
    }

    // Change to first image
    changeImage(imageThumbnails.querySelector('img'));

    /* imageLightbox.once('slide_changed', (event) => {
        // TODO Change selected image to the lightbox one?
        console.log(event);
    }); */

    showLoader(false);
}

async function main() {
    /* // Setup lightbox
    imageLightbox = GLightbox({
        autoplayVideos: true,
        touchNavigation: true,
        loop: true,
    });

    imageMain.onclick = () => imageLightbox.open(); */

    // Get product
    productId = parseInt((document.querySelector('[name=product_id]') as HTMLInputElement).value)

    variationSelect = document.querySelector('#variation');

    // If simple product
    if (!variationSelect) {
        changeVariation(productId);
        return;
    }

    // If variation product

    // Select first variation
    if (!variationSelect.value) {
        variationSelect.value = variationSelect.querySelector('option:not([value=""])').getAttribute('value');
    }

    setTimeout(() => {
        changeVariation(parseInt(variationIdInput.value));
    }, 200);

    let lastVariationId = variationIdInput.value ?? '0';

    // Wait for the variation ID to change
    do {
        let variationId: number|string; 

        await new Promise(r => setTimeout(r, 100));

        variationId = variationIdInput.value ?? '0';

        if (variationId && lastVariationId != variationId) {
            changeVariation(parseInt(variationId));
        }

        lastVariationId = variationId;

    } while (true);
}

// Only run if on a product page
if (document.body.classList.contains('single-product')) {
    main();
}

